import type { ButtonHTMLAttributes, FC } from 'react';

import cn from 'classnames';

export type SolidButtonVariant = 'primary' | 'subtle' | 'destructive';

const solidButtonVariants: Record<SolidButtonVariant, string> = {
  primary: 'bg-black hover:bg-black/90 text-white',
  subtle: 'bg-black/5 text-black hover:bg-black/10',
  destructive: 'bg-red-600 hover:bg-red-500 text-white',
};

interface SolidButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant: SolidButtonVariant;
}

// Full-width solid action button — the dialog/sheet action style (ConfirmDialog,
// mobile form footers), as opposed to the glassy PillButton used over feed content.
export const SolidButton: FC<SolidButtonProps> = ({ variant, className, type = 'button', children, ...props }) => (
  <button
    type={type}
    className={cn(
      'w-full rounded-full py-3 text-base font-semibold leading-6 transition-colors disabled:opacity-50',
      solidButtonVariants[variant],
      className,
    )}
    {...props}
  >
    {children}
  </button>
);
